import { LocalAuth } from "@core/model/local-auth";
import { LocalProfile } from "@core/model/local-profile";
import { LocalRoleIdentity } from "@core/model/local-role-identity";
import { decodeJwt } from "@core/utility/jwt-decode";
import { AUTH, PROFILE } from "@core/utility/settings";
import StorageService from "@shared/services/storage.service";
import { useCallback } from "react";

export function useUserIdentity() {
  const getUser = useCallback(
    () => StorageService.load<LocalProfile>(PROFILE),
    []
  );

  const getAuthUser = useCallback(
    () => StorageService.load<LocalAuth>(AUTH),
    []
  );

  const userIsAdmin = useCallback(() => {
    const user = StorageService.load<LocalProfile>(PROFILE);
    if (!user) return false;

    const role = user.roleName || "";
    const adminLevelRoles = ["admin"];
    const hasAdminLevel = adminLevelRoles.indexOf(role.toLowerCase()) >= 0;
    return hasAdminLevel;
  }, []);

  const getUserTokenEntity = useCallback(() => {
    const user = StorageService.load<LocalAuth>(AUTH);
    if (!user) return false;

    return decodeJwt(user.accessToken);
  }, []);

  const getUserRole = useCallback(() => {
    const entity = getUserTokenEntity() as any;

    return entity.roles as LocalRoleIdentity;
  }, []);

  return {
    getUser,
    userIsAdmin,
    getUserRole,
    getUserTokenEntity,
    getAuthUser,
  };
}
